import { FormattedMessage } from 'react-intl';
import { useState, useRef } from 'react';
import { clsx } from 'clsx';
import BlockTitle from '../../../layout/BlockTitle';
import GrayBox from '../../../layout/GrayBox';
import { useOutsideClick } from '../../../../../utils/useOutsideClick';
import dropdownIcon from '../../../../../../assets/icons/localization/dropdown-arrow.svg';
import styles from './RouterProtocolBlock.scss';

export const PROTOCOL_OPTIONS = ['OpenVPN', 'WireGuard'];
export type RouterProtocol = (typeof PROTOCOL_OPTIONS)[number];

interface RouterProtocolBlockProps {
  value: RouterProtocol;
  onChange: (protocol: RouterProtocol) => void;
  disabled?: boolean;
}

const RouterProtocolBlock = ({ value, onChange, disabled }: RouterProtocolBlockProps) => {
  const [isListShown, setIsListShown] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useOutsideClick(wrapperRef, () => {
    setIsListShown(false);
  });

  return (
    <article>
      <BlockTitle>
        <FormattedMessage id="profile.routerSection.protocolBlock.title" defaultMessage="VPN Protocol" />
      </BlockTitle>
      <div className={styles.selectWrapper} ref={wrapperRef}>
        <GrayBox className={styles.grayBox}>
          <button
            type="button"
            className={styles.selectButton}
            disabled={disabled}
            onClick={() => {
              if (!disabled) {
                setIsListShown((is) => !is);
              }
            }}
          >
            <span className={styles.label}>
              <FormattedMessage id="profile.routerSection.protocolBlock.selectLabel" defaultMessage="VPN Protocol" />
            </span>
            <span className={styles.valueRow}>
              <span className={styles.label}>{value}</span>
              <img
                className={clsx(styles.dropdownArrow, isListShown && styles.dropdownArrowRotated)}
                src={dropdownIcon}
                alt=""
              />
            </span>
          </button>
        </GrayBox>
        <ul className={clsx(styles.listWrapper, isListShown && styles.listWrapperShown)} aria-hidden={!isListShown}>
          {PROTOCOL_OPTIONS.map((protocol) => (
            <li key={protocol}>
              <button
                type="button"
                className={clsx(styles.optionButton, protocol === value && styles.optionButtonSelected)}
                onClick={() => {
                  onChange(protocol);
                  setIsListShown(false);
                }}
              >
                {protocol}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
};

export default RouterProtocolBlock;
